import {PALETTE_IDS} from '#core/application/modules/ids.js';

import {COLOR, FONT} from '../theme.js';

export function getMenuListsConfigs() {
    return {
        custom: {
            [PALETTE_IDS.MINI_EVENT_ITEM]: {
                QuickEventsNavigation: {
                    eventItem: {
                        content: {
                            eventTimingStatus: {
                                upcomingText: {
                                    style: {
                                        textAlign: 'center', //this custom config should be removed when 'SIN COMENZAR' translation is shortened one day
                                        whiteSpace: 'normal',
                                    },
                                },
                            },
                        },
                        contentActive: {
                            eventTimingStatus: {
                                upcomingText: {
                                    style: {
                                        textAlign: 'center', //this custom config should be removed when 'SIN COMENZAR' translation is shortened one day
                                        whiteSpace: 'normal',
                                    },
                                },
                            },
                        },
                    },
                },
            },
            [PALETTE_IDS.AZ_MENU]: {
                AzOverview: {
                    sectionName: {
                        container: {
                            margin: '0px 4px',
                        },
                    },
                },
            },
        },
        palette: {
            [PALETTE_IDS.MINI_EVENT_ITEM]: {
                MINI_EVENT_ITEM_BG: COLOR.BRAND.BACKGROUND1,
                MINI_EVENT_ITEM_SELECTED_BG: COLOR.BRAND.ACCENT3,
                MINI_EVENT_ITEM_SELECTED_CONTENT: {
                    MINI_EVENT_ITEM_TIMING_STATUS: {
                        EVENT_TIMING_LIVE_TEXT: {
                            color: COLOR.BRAND.FOREGROUND4,
                            whiteSpace: 'normal',
                            wordBreak: 'break-word',
                        },
                        EVENT_TIMING_UPCOMING_TEXT: COLOR.BRAND.FOREGROUND4,
                        EVENT_TIMING_STREAMING_INDICATOR: {
                            INDICATOR_ICON_COLOR: COLOR.BRAND.FOREGROUND4,
                        },
                    },
                    MINI_EVENT_ITEM_SCOREBOARD: {
                        MINI_SCOREBOARD_SCORES_TEXT: COLOR.BRAND.FOREGROUND4,
                        MINI_SCOREBOARD_SCORE_COUNT_TEXT: COLOR.BRAND.FOREGROUND4,
                        MINI_SCOREBOARD_SERVER_INDICATOR: COLOR.BRAND.FOREGROUND4,
                        MINI_SCOREBOARD_SEGMENT_INDICATOR_TEXT: COLOR.BRAND.FOREGROUND4,
                    },
                    MINI_EVENT_ITEM_PARTICIPANTS: {
                        PARTICIPANTS_TEXT: {
                            color: COLOR.BRAND.FOREGROUND4,
                            fontWeight: FONT.WEIGHT_NORMAL,
                        },
                    },
                },
            },
            [PALETTE_IDS.LIST_ITEM]: {
                LIST_ITEM_SELECTED_TEXT: COLOR.BRAND.FOREGROUND5,
                LIST_ITEM_TEXT: {
                    color: `${COLOR.BRAND.FOREGROUND1}|${COLOR.BRAND.BACKGROUND1}`,
                    fontSize: FONT.SIZE_MEDIUM,
                },
                LIST_ITEM_SELECTED_BG: COLOR.BRAND.ACCENT3,
            },
            [PALETTE_IDS.MENUS_LINKS_LISTS]: {
                LHM_HEADER_BG: COLOR.BRAND.BACKGROUND5,
                LHM_HEADER_TEXT: COLOR.BRAND.FOREGROUND4,
            },
            [PALETTE_IDS.AZ_MENU]: {
                MOBILE_AZ_SECTION_HEADER_CONTAINER_BG: COLOR.BRAND.BACKGROUND5,

                MOBILE_AZ_SECTION_HEADER_TEXT: {
                    color: COLOR.BRAND.FOREGROUND5,
                    fontWeight: FONT.WEIGHT_SEMI_BOLD,
                    fontSize: FONT.SIZE_MEDIUM,
                },
                MOBILE_AZ_CLOSE_BUTTON: {
                    CIRCULAR_CLOSE_BUTTON_BG: COLOR.BRAND.BACKGROUND3,
                    CIRCULAR_CLOSE_BUTTON_ICON_COLOR: COLOR.BRAND.FOREGROUND1,
                },
            },
            [PALETTE_IDS.QUICK_NAVIGATIONS]: {
                QUICK_NAVIGATIONS_TITLE_TEXT: {
                    color: COLOR.BRAND.FOREGROUND1,
                    fontSize: FONT.SIZE_MEDIUM,
                    fontWeight: FONT.WEIGHT_BOLD,
                    textTransform: 'capitalize',
                },
            },
        },
    };
}
